export default {
  formSignatures: [],
  formSignature: undefined,
};
